export const isShowLinkedClients = () => !(window.localStorage.getItem("ShowLinkedClients") === "false")
